import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export const CTABand = ({
  title = "Ready to Work With Iconicho?",
  copy = "Tell us about your project, contract, or procurement need — and we'll structure the right solution.",
  testId = "cta-band",
}) => (
  <section className="noise-overlay bg-navy" data-testid={testId}>
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-gold" />
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-white/60">
            Next Steps
          </span>
        </div>
      </Reveal>
      <div className="mt-8 flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
        <Reveal delay={0.05}>
          <h2 className="max-w-xl font-heading text-3xl font-extrabold tracking-tight text-white text-balance sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-5 max-w-xl leading-relaxed text-white/60">{copy}</p>
        </Reveal>
        <Reveal delay={0.12}>
          <Link
            to="/contact"
            data-testid={`${testId}-button`}
            className="group inline-flex shrink-0 items-center gap-3 rounded-sm bg-gold px-8 py-4 text-sm font-medium tracking-wide text-white transition-colors duration-300 hover:bg-gold-dark"
          >
            Work With Iconicho
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
